import type { FC } from 'react'
import { useState } from 'react'

import VerifyButton from '@/components/VerifyButton'
import type { CompanyDetails } from '@/types/Activity'

import VerifyOrganisationFinanceSidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  company: CompanyDetails
}

const VerifyOrganisationFinance: FC<Props> = ({ customerId, subjectId, company }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <VerifyOrganisationFinanceSidebar
          customerId={customerId}
          subjectId={subjectId}
          finance={company.finance}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <VerifyButton
        onClick={() => setIsSidebarOpen(true)}
        disabled={company?.verification?.verifiedBy === undefined}
      />
    </>
  )
}

export default VerifyOrganisationFinance
